// extracted by mini-css-extract-plugin
export var lightMode = "_t-0";